import client from 'src/api/client';
import { AxiosResponse } from 'axios';
import { BASE_URL } from 'src/config/api';
import { ProductResponse } from 'src/admin-entity/interface/chat-product/chat-product.interface';

export const fetchProducts = (lsBroadcastId: number): Promise<AxiosResponse<ProductResponse[]>> => {
    return client.get(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/product`);
};

export const addProduct = (lsBroadcastId: number, productIds: number[]): Promise<AxiosResponse<ProductResponse[]>> => {
    return client.post(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/product`, { productIds });
};

export const deleteProduct = (lsBroadcastId: number, productId: number): Promise<AxiosResponse<ProductResponse[]>> => {
    return client.delete(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/product/${productId}`);
};

export const setProductSortOrder = (
    lsBroadcastId: number,
    order: number[],
): Promise<AxiosResponse<ProductResponse[]>> => {
    return client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/product/sort`, order);
};

export const updateProductVisibility = (
    lsBroadcastId: number,
    productId: number,
    productActive: boolean,
): Promise<AxiosResponse<ProductResponse[]>> => {
    return client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/product/${productId}/active`, { productActive });
};

export const updateProductNowStatus = (
    lsBroadcastId: number,
    productId: number,
    productNow: boolean,
): Promise<AxiosResponse<ProductResponse[]>> => {
    return client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/product/${productId}/now`, { productNow });
};
